import React from 'react';
interface CcciaLogoProps {
  tone?: 'dark' | 'light';
}
export function CcciaLogo({
  tone = 'dark'
}: CcciaLogoProps) {
  const word = tone === 'dark' ? 'text-navy' : 'text-white';
  const sub = tone === 'dark' ? 'text-muted' : 'text-white/75';
  return <span className="inline-flex items-center gap-2.5" aria-label="Cape Coral Construction Industry Association" data-id="element-34" data-mp="2o9u0v8e3uin1">
      <svg viewBox="0 0 44 36" className="h-9 w-11 text-cccia" aria-hidden="true" data-id="element-35" data-mp="1wgjsxyxd71s7">
        <path d="M3 18 L22 4 L41 18 M8 15 V33 H36 V15 M18 33 V22 H26 V33 M30 8 V12" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-36" data-mp="1winvodjj1uqw" />
      </svg>
      <span className="flex flex-col leading-none" data-id="element-37" data-mp="20hdg2q2zgck1">
        <span className={`font-display text-xl font-bold tracking-wide ${word}`} data-id="element-38" data-mp="3gwenjvjmy6k9">CCCIA</span>
        <span className={`mt-1 text-[9px] font-medium uppercase tracking-wider ${sub}`} data-id="element-39" data-mp="3bxbu78d0pos4">
          Construction Industry Assoc.
        </span>
      </span>
    </span>;
}